module.exports = __webpack_public_path__ + "img/logo_goAllOutMan.6a359887.png";